import { isIso4217 } from "@payair/e-com-common-sdk/core/Validators";
/**
 * Payair Samsung Pay transaction options type.
 */
var SamsungPayInitParams = /** @class */ (function () {
    function SamsungPayInitParams() {
    }
    return SamsungPayInitParams;
}());
export { SamsungPayInitParams };
/** @internal */
export var convertInitParams = function (samsungPayInitParams) {
    var samsungPayPaymentRequest = samsungPayInitParams.samsungPayPaymentRequest;
    var samsungPayConfiguration = {
        version: "1",
        productId: samsungPayInitParams.merchantId.productId,
        allowedCardNetworks: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.allowedCardNetworks)
            ? samsungPayPaymentRequest.allowedCardNetworks
            : ["mastercard", "visa"],
        orderNumber: samsungPayInitParams.transactionId,
        merchantName: samsungPayInitParams.merchantName,
        merchantGatewayParameter: { userId: samsungPayInitParams.merchantId.userId },
        isRecurring: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.isRecurring) ? samsungPayPaymentRequest.isRecurring : false,
        billingAddressRequired: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.billingAddressRequired)
            ? samsungPayPaymentRequest.billingAddressRequired
            : false,
        paymentProtocol: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.paymentProtocol)
            ? samsungPayPaymentRequest.paymentProtocol
            : "PROTOCOL_3DS",
    };
    var defaultCurrencyAmount = {
        currency: samsungPayInitParams.currencyCode,
        value: samsungPayInitParams.totalAmount,
    };
    var defaultPaymentItem = {
        amount: defaultCurrencyAmount,
        label: samsungPayInitParams.totalAmountLabel,
    };
    var samsungPayPaymentDetails = samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.samsungPayPaymentDetails;
    var samsungPayDetails = {
        displayItems: (samsungPayPaymentDetails === null || samsungPayPaymentDetails === void 0 ? void 0 : samsungPayPaymentDetails.displayItems) ? samsungPayPaymentDetails.displayItems : [],
        total: (samsungPayPaymentDetails === null || samsungPayPaymentDetails === void 0 ? void 0 : samsungPayPaymentDetails.total) ? samsungPayPaymentDetails.total : defaultPaymentItem,
    };
    var samsungPayOptions = {
        requestShipping: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.requestShipping) ? samsungPayPaymentRequest.requestShipping : false,
        requestPayerEmail: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.requestPayerEmail) ? samsungPayPaymentRequest.requestPayerEmail : false,
        requestPayerPhone: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.requestPayerPhone) ? samsungPayPaymentRequest.requestPayerPhone : false,
        requestPayerName: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.requestPayerName) ? samsungPayPaymentRequest.requestPayerName : false,
        shippingType: (samsungPayPaymentRequest === null || samsungPayPaymentRequest === void 0 ? void 0 : samsungPayPaymentRequest.shippingType) ? samsungPayPaymentRequest.shippingType : undefined,
    };
    var samsungPayPaymentMethodData = [
        {
            supportedMethods: "https://spay.samsung.com",
            data: samsungPayConfiguration,
        },
    ];
    return [samsungPayPaymentMethodData, samsungPayDetails, samsungPayOptions];
};
/** @internal */
export var validateInitParams = function (samsungPayInitParams) {
    var errorMessage = [];
    if (!samsungPayInitParams) {
        errorMessage.push("samsungPayInitParams not defined");
        return errorMessage;
    }
    //transactionID validation
    if (!samsungPayInitParams.transactionId) {
        errorMessage.push("transactionId not defined");
    }
    // locale validation
    if (!samsungPayInitParams.locale) {
        errorMessage.push("locale is not defined");
    }
    else if (samsungPayInitParams.locale !== "en_GB") {
        errorMessage.push("locale is not valid, only 'en_GB' is supported");
    }
    // currencyCode validation
    if (!samsungPayInitParams.currencyCode) {
        errorMessage.push("currencyCode is not defined");
    }
    else if (!isIso4217(samsungPayInitParams.currencyCode)) {
        errorMessage.push("currencyCode is not valid");
    }
    //TODO do each googlePayInitParams field validation
    return errorMessage;
};
